export default __webpack_public_path__ + "static/lsa-website-2-fec12e0257090692e6944ad06bda2ced.jpg";